import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type EmailToSmsPageStore } from '../store/emailToSmsPageStore'

export const EmailToSmsPageStorePageContext = createContext<EmailToSmsPageStore | null>(null)

export const useEmailToSmsPageStorePageContext = () => {
  const context = useContext(EmailToSmsPageStorePageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with EmailToSmsPageStorePageContext'
    )

  return context
}

type IProviderEmailToSmsPageStorePageProps = {
  value: EmailToSmsPageStore
  children: ReactNode
}

export const ProviderPageEmailToSmsPageStore: FC<IProviderEmailToSmsPageStorePageProps> = ({
  value,
  children,
}) => {
  return (
    <EmailToSmsPageStorePageContext.Provider value={value}>
      {children}
    </EmailToSmsPageStorePageContext.Provider>
  )
}
